import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const trustItems = [
  { icon: 'ri-shield-check-fill', label: '100% Approval Guaranteed' },
  { icon: 'ri-calendar-check-line', label: 'Month-to-Month · No Contracts' },
  { icon: 'ri-flashlight-fill', label: 'Quick Turnaround' },
  { icon: 'ri-global-line', label: 'US & International Coverage' },
  { icon: 'ri-user-star-line', label: 'Same Expert — Every Interaction' },
];

export default function TrustBar() {
  const { ref, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section className="relative bg-[#111111]">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A030]/40 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A030]/10 to-transparent" />

      <div
        ref={ref}
        className={`w-full px-6 lg:px-14 py-5 flex flex-wrap items-center justify-center gap-x-0 gap-y-0 fade-in ${isVisible ? 'visible' : ''}`}
      >
        {trustItems.map((item, idx) => (
          <div key={idx} className="flex items-center group">
            <div className="flex items-center gap-2.5 px-6 py-3">
              <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-[#C9A030] text-sm`} />
              </span>
              <span className="text-[#F2EDE3]/55 text-[10px] tracking-[0.22em] uppercase font-medium whitespace-nowrap group-hover:text-[#F2EDE3]/80 transition-colors duration-200">
                {item.label}
              </span>
            </div>
            {idx < trustItems.length - 1 && (
              <span className="hidden xl:block w-px h-3.5 bg-[#C9A030]/20" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
